module.exports = __webpack_public_path__ + "img/exchange.9fb7c1b2.svg";